/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/qaWorkspaceLayout.ts
 * FILE_ID: JOBHUB-QA-WORKSPACE-LAYOUT-001
 * PURPOSE: Class helpers for the QA areas split and the phone accordion.
 * WHY: Tablet needs independent left/right scroll. Phone must not keep the
 *      two-column split — the table sits under the open area item.
 * FLOW:
 *   ┌──────────┐   ┌──────────────┐   ┌────────────┐
 *   │ surface  │ → │ class bundle │ → │ pane / row │
 *   └──────────┘   └──────────────┘   └────────────┘
 */

export const QA_SPLIT_CLASS =
  'hidden md:grid md:min-h-[28rem] md:sticky md:top-[var(--qa-rail-top,0px)] md:z-0'

export const QA_MODE_BODY_SCROLL_CLASS = 'min-w-0 lg:max-h-[var(--qa-pane-max-h,min(70vh,40rem))] lg:overflow-y-auto'

// Column 2 only earns its width on lg. Below that it collapses to a chip row
// above the table (see QaChecklistRail), because a 220px column on a tablet
// leaves the table unreadable.
export const QA_BUILD_SPLIT_CLASS =
  'hidden gap-4 md:grid md:grid-cols-[260px_1fr] lg:grid-cols-[260px_220px_1fr] md:min-h-[28rem]'

export const QA_BUILD_DETAIL_SPLIT_CLASS =
  'flex flex-col gap-2 lg:grid lg:min-h-[24rem]'

export const QA_PANE_SCROLL_CLASS =
  'min-w-0 md:max-h-[var(--qa-pane-max-h,min(70vh,40rem))] md:overflow-y-auto'

// Build hands vertical scroll to the table alone: a scrolling pane or body
// around it carries the sticky header row and checklist heading away.
export const QA_TABLE_SCROLL_CLASS = 'max-h-[var(--qa-pane-max-h,min(70vh,40rem))] overflow-auto'

export const QA_BUILD_PANE_CLASS = 'min-w-0'

export const QA_PHONE_STACK_CLASS = 'space-y-3 md:hidden'

export const QA_TEST_TAB_ROW_CLASS =
  'flex flex-nowrap gap-2 overflow-x-auto overscroll-x-contain pb-1'

export const QA_PACK_ACTIONS_CLASS = 'flex min-w-0 flex-col items-stretch gap-2'

export const QA_PACK_TYPE_ROW_CLASS =
  'flex min-w-0 flex-wrap rounded-lg border border-border p-0.5'

export const QA_CHECKLIST_ACTIONS_CLASS = 'flex flex-nowrap items-center gap-2'
